import axiosInstance from '../AxiosInstance';
import Api from '../../constants/Api';

// Conexões do WhatsApp das empresas, gerenciadas pela Plataforma (somente super admin).
const WhatsappConnectionService = {
    // Lista as conexões das empresas com a forma de conexão e o último webhook recebido.
    list() {
        return axiosInstance.get(`${Api.parameter.whatsapp_superadmin}/connections`);
    },
    // Conecta (ou atualiza) o WhatsApp de uma empresa com o app próprio dela na Meta.
    connectManually(companyId, payload) {
        return axiosInstance.post(`${Api.parameter.whatsapp_superadmin}/${companyId}/manual-connection`, payload);
    },
    // URL e token de verificação do webhook do Colmeia, para colar no app da empresa.
    setupInfo() {
        return axiosInstance.get(Api.parameter.whatsapp_meta_setup_info);
    }
};

export default WhatsappConnectionService;
